// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3Cyfj","additionalInfo":"AgreementModal_additionalInfo__2QFTj"};